const EVENT = "klt-export-submitted";

export function notifyExportSubmitted() {
  window.dispatchEvent(new Event(EVENT));
}

export function onExportSubmitted(show: () => void) {
  window.addEventListener(EVENT, show);
  return () => window.removeEventListener(EVENT, show);
}
